import { render, staticRenderFns } from "./membership.vue?vue&type=template&id=52e8556c&scoped=true"
import script from "./membership.vue?vue&type=script&lang=js"
export * from "./membership.vue?vue&type=script&lang=js"
import style0 from "./membership.vue?vue&type=style&index=0&id=52e8556c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e8556c",
  null
  
)

export default component.exports